import { apiFetch } from "@/lib/api";

export interface InsideSalesSalesOrderRow {
  id: number;
  number: string;
  status: string | null;
  mv_id: number | null;
  rep_agency_id: number | null;
  rep_staff_id: number | null;
  rep_agency_name: string | null;
  rep_staff_display_name: string | null;
  rep_sync_at: string | null;
  rep_sync_freshdesk_ticket_id: number | null;
  client_fs_account_name: string | null;
  end_user_fs_account_name: string | null;
  submitted: string | null;
  sgs_ship_by_date: string | null;
  ship_to_recipient: string | null;
  ship_to_city: string | null;
  ship_to_state: string | null;
  payment_terms: string | null;
  customer_purchase_order_number: string | null;
  special_instructions: string | null;
}

export async function fetchInsideSalesSalesOrders(search: string): Promise<InsideSalesSalesOrderRow[]> {
  const response = await apiFetch<{ ok: true; rows: InsideSalesSalesOrderRow[] }>("/api/inside-sales/sales-orders", {
    query: search.trim() !== "" ? { q: search.trim() } : undefined,
  });
  return response.rows;
}

export async function fetchInsideSalesSalesOrderDetail(
  salesOrderId: number,
): Promise<InsideSalesSalesOrderRow> {
  const response = await apiFetch<{ ok: true; row: InsideSalesSalesOrderRow }>(
    `/api/inside-sales/sales-orders/${salesOrderId}`,
  );
  return response.row;
}

export async function rerunInsideSalesSalesOrderRepSync(salesOrderId: number): Promise<{
  sync: {
    outcome: string;
    freshdeskTicketId: number | null;
    repSyncAt: string | null;
    assignment: { errors: Array<{ code: string; message: string }> } | null;
  };
  row: InsideSalesSalesOrderRow;
}> {
  return apiFetch(`/api/inside-sales/sales-orders/${salesOrderId}/rep-sync`, { method: "POST" });
}
